import { fromJS } from "immutable"
import {
  GET_DIVISION_RATE_WATCHER,
  GET_DIVISION_RATE_SUCCESS,
  GET_DIVISION_RATE_FAILED,
} from "./constants"

export const initialState = fromJS({
  isLoading: true,
  divisionsRate: [],
})

function widgetResponseRateReportReducer(state = initialState, action) {
  switch (action.type) {
    case GET_DIVISION_RATE_WATCHER:
      return state.set("isLoading", true)

    case GET_DIVISION_RATE_SUCCESS:
      return state
        .set("isLoading", false)
        .set("divisionsRate", action.payload)

    case GET_DIVISION_RATE_FAILED:
      return state.set("isLoading", false).set("divisionsRate", [])

    default:
      return state
  }
}

export default widgetResponseRateReportReducer
